"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HUB_SETTINGS_CONSENT_KEYS = exports.CONSENT_FIELDS = exports.LANGUAGES = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _I18n = _interopRequireDefault(require("I18n"));

var LANGUAGES = [].concat((0, _toConsumableArray2.default)(Object.keys(_I18n.default.baseLocales)), (0, _toConsumableArray2.default)(Object.keys(_I18n.default.publicLocales)));
exports.LANGUAGES = LANGUAGES;
var CONSENT_FIELDS = ['communicationConsentText', 'communicationConsentCheckboxes', 'implicitProcessingConsentText', 'explicitProcessingConsentText', 'explicitProcessingConsentCheckboxLabel', 'privacyPolicyText', 'legitimateInterestPrivacyPolicyText'];
exports.CONSENT_FIELDS = CONSENT_FIELDS;
var HUB_SETTINGS_CONSENT_KEYS = [];
exports.HUB_SETTINGS_CONSENT_KEYS = HUB_SETTINGS_CONSENT_KEYS;
LANGUAGES.forEach(function (lang) {
  CONSENT_FIELDS.forEach(function (field) {
    HUB_SETTINGS_CONSENT_KEYS.push(field + ":" + lang);
  });
});